import billingApi from '@/app/services/api/billing';

const mutations = {
  SET_BILLING_API(state, payload) {
    state.api = payload;
  },
  SET_PRICES(state, payload) {
    state.prices = payload;
  },
  SET_SUBSCRIPTIONS(state, payload) {
    state.subscriptions = payload;
  },
};

const actions = {
  initBillingAPI({ commit, dispatch, rootGetters }) {
    let billingAPI;
    if (typeof billingApi === 'function') {
      billingAPI = billingApi(rootGetters['account/getActiveAccount'].uuid);
    } else {
      billingAPI = billingApi;
    }
    commit('SET_BILLING_API', billingAPI);
    dispatch('getPrices');
    if (rootGetters['account/isAccountOwner']) {
      dispatch('getSubscriptions');
    }
  },
  clearBilling: {
    root: true,
    handler: function clearBilling({ commit }) {
      commit('SET_BILLING_API', null);
      commit('SET_PRICES', []);
      commit('SET_SUBSCRIPTIONS', []);
    },
  },
  getPrices({ state, commit, dispatch }) {
    dispatch('toggleLoading', true, { root: true });
    if (!state.api) {
      return dispatch('initBillingAPI');
    }
    return state.api.getPrices().then((res) => {
      dispatch('toggleLoading', false, { root: true });
      commit('SET_PRICES', res.data.products);
    });
  },
  getSubscriptions({ state, commit, dispatch }) {
    dispatch('toggleLoading', true, { root: true });
    if (!state.api) {
      return dispatch('initBillingAPI');
    }
    return state.api.getSubscriptions()
      .then((res) => {
        dispatch('toggleLoading', false, { root: true });
        if (res) {
          commit('SET_SUBSCRIPTIONS', res.data.data);
        }
      });
  },
};

const getters = {
  getPrices(state) {
    return state.prices;
  },
  getPriceByProduct(state) {
    return product => state.prices.filter(price => price.app === product)[0];
  },
  getPurchases(state) {
    return state.prices.filter(product => product.metadata.type === 'PURCHASE');
  },
  getSubscriptions(state) {
    return state.subscriptions;
  },
  getSubscriptionByProduct(state) {
    return product => state.subscriptions.filter(sub => sub.app === product);
  },
  hasSubscriptionByProduct(state) {
    return product => state.subscriptions.filter(sub => sub.app === product).length > 0;
  },
};

const state = {
  api: null,
  prices: [],
  subscriptions: [],
};

const store = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};

export default store;
